import { Icon } from '@iconify/react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const addressDataList = [
  '+254 790 915 190',
  'Nairobi, Kenya',
  'info@soketrysolutions.co.ke',
];
const serviceMenuList = [
  {
    title: 'Custom Quotations',
    href: '/service/custom-quotations',
  },
  {
    title: 'Product Sales',
    href: '/service/product-sales',
  },
  {
    title: 'Site Assessments and Energy Audits',
    href: '/service/site-assessments-energy-audits',
  },
  {
    title: 'Installation Services',
    href: '/service/installation-services',
  },
  {
    title: 'After Sales Services',
    href: '/service/after-sales',
  },
  {
    title: 'Financing Options',
    href: '/service/financing-options',
  },
];

const LinksMenuList = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'About',
    href: '/about',
  },
  {
    title: 'Services',
    href: '/service',
  },
  {
    title: 'Portfolio',
    href: 'portfolio',
  },
  // {
  //   title: 'Blog',
  //   href: '/blog',
  // },
  {
    title: 'Contact',
    href: '/contact',
  },
];
// const policyMenuList = [
//   {
//     title: 'Terms of Use',
//     href: '/',
//   },
//   {
//     title: 'Privacy Policy',
//     href: '/',
//   },
// ];
const socialBtnList = [
  {
    icon: 'fa6-brands:linkedin-in',
    href: 'https://www.linkedin.com/in/soketrysolutions/',
  },
  {
    icon: 'fa6-brands:twitter',
    href: 'https://x.com/soketrysolutions/',
  },
  {
    icon: 'fa6-brands:youtube',
    href: 'https://www.youtube.com/soketrysolutions',
  },
  {
    icon: 'fa6-brands:tiktok',
    href: 'https://vm.tiktok.com/ZMkUHL5Ga/',
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({
    submitting: false,
    message: null
  });

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, message: null });

    try {
      const response = await emailjs.send(
        'EMAILJS_SERVICE_ID',
        'EMAILJS_TEMPLATE_ID',
        {
          from_email: email,
          subscription_type: 'Newsletter',
          to_email: 'info@soketrysolutions.co.ke',
          message: 'New newsletter subscription request'
        },
        'EMAILJS_PUBLIC_KEY'
      );

      if (response.status === 200) {
        setStatus({
          submitting: false,
          message: { type: 'success', text: 'Successfully subscribed!' }
        });
        setEmail('');
      }
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
      setStatus({
        submitting: false,
        message: { type: 'error', text: 'Subscription failed. Please try again.' }
      });
    }
  };

  return (
    <footer
      className="cs_fooer cs_bg_filed"
      style={{ backgroundImage: 'url(/images/footer_bg.jpg)' }}
    >
      <div className="cs_fooer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <div className="cs_text_widget">
                  <img src="/images/logo_white.png" alt="Logo" />
                </div>
                <ul className="cs_menu_widget cs_mp0">
                  {addressDataList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Services</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {serviceMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Links</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {LinksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Subscribe Newsletter</h2>
                <div className="cs_newsletter cs_style_1">
                  <div className="cs_newsletter_text">
                    We make sure to only send emails that are noteworthy and
                    pertinent to the recipient.
                  </div>
                  <form onSubmit={handleNewsletterSubmit} className="cs_newsletter_form">
                    <input
                      type="email"
                      className="cs_newsletter_input"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    {status.message && (
                      <div className={`cs_alert cs_alert_${status.message.type} cs_newsletter_alert`}>
                        {status.message.text}
                      </div>
                    )}
                    <button 
                      className="cs_btn cs_style_1"
                      type="submit"
                      disabled={status.submitting}
                    >
                      {status.submitting ? 'Submitting...' : 'Submit'}
                      <span>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="cs_bottom_footer">
          <div className="cs_bottom_footer_left">
            <div className="cs_social_btns cs_style_1">
              {socialBtnList.map((item, index) => (
                <Link to={item.href} className="cs_center" key={index}>
                  <Icon icon={item.icon} />
                </Link>
              ))}
            </div>
          </div>
          <div className="cs_copyright">Copyright © 2024 Heissal.</div>
          <div className="cs_bottom_footer_right">
            {/* <ul className="cs_footer_links cs_mp0">
              {policyMenuList.map((item, index) => (
                <li key={index}>
                  <Link to={item.href}>{item.title}</Link>
                </li>
              ))}
            </ul> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
